
import { defineComponent } from "vue";
// import { ref, watch } from "vue";

export default defineComponent({
  name: "shotsDisplay",
  props: ["shots"],
});
